export default __webpack_public_path__ + "static/media/CHANGELOG.4add71ad.md";